import ManufacturerRepository from "@/repositories/vns/ManufacturerRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'manufacturer',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ManufacturerRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.manufacturer)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await ManufacturerRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.manufacturers)
                if (response.data.data.meta && Object.keys(response.data.data.meta).length > 0){
                    commit('setPagination', response.data.data.meta)
                }
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await ManufacturerRepository.search(params).then(response => {
                if (response.data.data.manufacturers.length > 0){
                    const array = response.data.data.manufacturers
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
